import React from 'react'
import * as flightInfoTypes from '../../flightDetail/flightInfoTypes'

const FlightInfo = (props) => {
   
    
    let {selectedFlightInfo} = props
    let flightNumber = selectedFlightInfo.FltNum
    let departTime = selectedFlightInfo.flightDirection == flightInfoTypes.INBOUND ? selectedFlightInfo.ETA : selectedFlightInfo.ETD

    return  (
        <div className="fullWidth">
            <div className="flightNumberDisplay">
                <div className="flightCode">PD</div>
               <div className="flightNumber" >{flightNumber} <span className="tailNumber">/ {props.selectedFlightInfo.UncorrectedTailNum}</span></div>
            </div>
            <div className="cityTime">{props.selectedFlightInfo.DepAirport} - {props.selectedFlightInfo.ArrAirport} / {departTime} </div>
            <div className="clear"></div>
        </div>
    )
}

export default FlightInfo